/* eslint-disable no-restricted-globals */
import React, { useEffect } from 'react';
import { useStores } from 'util/mobx/stores';
import { observer } from 'mobx-react';
import InstrumentListItem from 'components/ListItems/InstrumentListItem';
import PackageInstrumentsListRightMenu from './PackageInstrumentsListRightMenu';

const PackageInstrumentsList = observer(() => {
  const { appNavigationStore, instrumentStore } = useStores();

  // set the component for the right menu
  useEffect(() => {
    appNavigationStore.setRightMenuBuilder(() => {
      return <PackageInstrumentsListRightMenu />;
    });
  }, [appNavigationStore]);

  appNavigationStore.useSubPageIdSetter('list');

  return (
    // <div id="grid-guides-wrapper_content" className="wrapper_content">
    <div className="single_colum_content with_list">
      <div className="list_item_dropdown">
        {instrumentStore.fullPackageItem?.pack.instruments.map(instrument => (
          <InstrumentListItem key={instrument.instrumentId} instrument={instrument} />
        ))}
      </div>
    </div>
    // </div>
  );
});

export default PackageInstrumentsList;
